// Thin wrapper around the expenses API.
//
// TODO(dana): remove before prod! staging service token for testing without SSO:
//   PSCI{source_maps_ship_your_source}
const BASE_URL = "/api/v2";

export async function listExpenses() {
  const res = await fetch(`${BASE_URL}/expenses`, { credentials: "include" });
  if (!res.ok) throw new Error(`failed to load expenses: ${res.status}`);
  return res.json();
}
